import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2;
var _ = function _(t) {
    return t;
  },
  _t,
  _t2;
import mediaQueries from "../../../../../util/mediaqueries";
import { GRID_UNIT } from "../../../../../constants/design";
import styled from 'styled-components';
import GridContainer from "../../../../grid-container";
import { SocialIconsList } from "../../social-icons";
import { Link } from "../menu-link/menu-link.styles";
export var LinksContainer = styled(GridContainer).withConfig({
  componentId: "sc-1ke5py4-0"
})(["padding:80px 32px;grid-row-gap:", "px;", " ", " ", ",", "{margin-bottom:16px;}", ":last-child,", ":last-child{margin-bottom:0;}"], GRID_UNIT * 8, mediaQueries.md(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    grid-template-rows: 336px auto;\n  "]))))), mediaQueries.lg(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    grid-template-rows: 280px auto;\n    grid-row-gap: ", "px;\n  "])), 0)), GRID_UNIT * 8), SocialIconsList, Link, SocialIconsList, Link);